import type { History, Location } from "history";

export type EditorPanel = "activity" | "performance";

export interface EditorParams {
  slide?: number | null;
  theme?: number | null;
  panel?: EditorPanel;
}

function parseId(value: string | null): number | null {
  if (value == null || value === "") return null;
  const id = Number(value);
  return Number.isInteger(id) && id > 0 ? id : null;
}

export function readEditorParams(search: string): { slide: number | null; theme: number | null; panel: EditorPanel } {
  const params = new URLSearchParams(search);
  return {
    slide: parseId(params.get("slide")),
    theme: parseId(params.get("theme")),
    panel: params.get("panel") === "performance" ? "performance" : "activity",
  };
}

/**
 * Sets (number) or deletes (null) `slide` and `theme`, and sets `panel` (absent for Activity), leaving
 * every other search param, such as the admin scope, untouched. Keys left undefined are not changed.
 */
export function writeEditorParams(history: History, location: Location, next: EditorParams): void {
  const params = new URLSearchParams(location.search);
  (["slide", "theme"] as const).forEach(key => {
    const value = next[key];
    if (value === undefined) return;
    if (value === null) params.delete(key);
    else params.set(key, String(value));
  });
  if (next.panel === "performance") params.set("panel", "performance");
  else if (next.panel === "activity") params.delete("panel");
  const search = params.toString();
  // Keep the router state (such as where the back link goes) across slide, theme, and panel changes.
  history.replace({ pathname: location.pathname, search: search ? `?${search}` : "", state: location.state });
}
